/** @typedef {'no_duplicado' | 'posible_duplicado' | 'duplicado_probable'} DuplicateStatus */

/**
 * @param {object|null|undefined} row
 * @returns {object|null}
 */
export function getComunidadDuplicateCheck(row) {
  const meta = row?.metadata && typeof row.metadata === 'object' ? row.metadata : null;
  const dc = meta?.duplicate_check;
  if (!dc || typeof dc !== 'object') return null;
  return dc;
}

/**
 * @param {object|null|undefined} dc
 * @returns {boolean}
 */
export function comunidadHasDuplicateAlert(dc) {
  if (!dc || dc.dismissed) return false;
  return dc.status === 'posible_duplicado' || dc.status === 'duplicado_probable';
}

/** @param {DuplicateStatus|string|null|undefined} status */
export function comunidadDuplicateStatusLabel(status) {
  if (status === 'duplicado_probable') return 'Dup. probable';
  if (status === 'posible_duplicado') return 'Posible dup.';
  return 'Sin dup.';
}

/** @param {DuplicateStatus|string|null|undefined} status */
export function comunidadDuplicateStatusColor(status) {
  if (status === 'duplicado_probable') return '#e24b4a';
  if (status === 'posible_duplicado') return '#ef9f27';
  return 'rgba(255,255,255,0.35)';
}

/**
 * @param {*} supabase
 * @param {string} publicacionId
 */
export async function refreshComunidadDuplicateCheck(supabase, publicacionId) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'comunidad_duplicate_refresh', payload: { publicacion_id: publicacionId } },
  });
  if (error) return { ok: false, error: error.message || 'invoke_failed' };
  if (!data?.ok) return { ok: false, error: data?.message || data?.error || 'unknown' };
  return { ok: true, duplicate_check: data.duplicate_check };
}

/**
 * @param {*} supabase
 * @param {string} publicacionId
 */
export async function dismissComunidadDuplicateCheck(supabase, publicacionId) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'comunidad_duplicate_dismiss', payload: { publicacion_id: publicacionId } },
  });
  if (error) return { ok: false, error: error.message || 'invoke_failed' };
  if (!data?.ok) return { ok: false, error: data?.message || data?.error || 'unknown' };
  return { ok: true, duplicate_check: data.duplicate_check };
}

/**
 * @param {*} supabase
 * @param {string} candidateId
 */
export async function loadComunidadDuplicateCandidate(supabase, candidateId) {
  const { data, error } = await supabase.functions.invoke('admin-actions', {
    body: { action: 'comunidad_duplicate_load_candidate', payload: { candidate_id: candidateId } },
  });
  if (error) return { ok: false, error: error.message || 'invoke_failed' };
  if (!data?.ok) return { ok: false, error: data?.message || data?.error || 'unknown' };
  return { ok: true, row: data.row };
}

/**
 * Tras publicar propuesta usuario (fire-and-forget).
 * @param {*} supabase
 * @param {string} publicationId
 */
export function triggerComunidadDuplicateCheckAfterPublish(supabase, publicationId) {
  if (!publicationId) return;
  supabase.functions.invoke('comunidad-duplicate-check', {
    body: { publication_id: publicationId },
  }).catch(() => {});
}
